import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../../constants/block-background-attributes';

const handleBackgroundOption = ({ destinationBlockNode, backgroundOption }) => {
  if (!backgroundOption) return;

  Object.entries(backgroundOption.values).forEach(([attribute, value]) => {
    if (!destinationBlockNode.hasAttribute(attribute)) return;

    destinationBlockNode.setAttribute(attribute, value);

    if (attribute === BACKGROUND_IMAGE_ATTRIBUTE && value) {
      destinationBlockNode.removeAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE);
    }
  });
};

export default handleBackgroundOption;
